import Vue from 'vue';

export default new Vue({
  data: {},
  methods: {
    async getInvoicesList(rawParams) {
      const params = {
        qInvoiceNumber: rawParams.qInvoiceNumber || undefined,
        qTaxId: rawParams.qTaxId || undefined,
        qCompanyName: rawParams.qCompanyName || undefined,
        sortOrder: rawParams.sortOrder || undefined,
        orderBy: rawParams.orderBy || undefined,
        offset: rawParams.offset || 0,
        pageSize: rawParams.pageSize || 10,
      };
      return await this.$http.get('/api/invoices', { params })
        .then(response => response);
    },
  }
});